import { Component, HostListener, OnChanges, OnInit, SimpleChanges } from '@angular/core';
//import { Chart } from 'angular-highcharts';
import { AgentService } from 'src/app/agent/services/agent.service';
import { BaseComponent } from 'src/app/system-common/base/base.component';
import { SettingService } from 'src/app/system-common/services/setting.service';
//import * as HighCharts from 'highcharts';
import { Router } from '@angular/router';
// import { event } from 'jquery';
import * as Chart from 'chart.js';
import { ChartYPlotDetails } from 'src/app/system-common/custom-charts/custom-charts.component';

@Component({
  selector: '',
  template: '',
})
export class AgentApplicationStatusHandlerComponent extends BaseComponent<AgentService> implements OnInit {
  chart: Chart;
  pieGraph: boolean;

  public agentApplicationStatusGraph: any;
  public agentApplicationStatusPieChartData = [];
  public agentApplicationStatusBarChartData = [];
  public agentApplicationStatusLineChartData = [];
  public searchName: string;
  public widthInPX;
  allocationPercLabels = [];
  pieColorArray = [];
  allocationPercData = [];
  lineGraph: boolean;
  barGraph: boolean;
  agentApplicationStatusBarChartLabels: any[];
  agentApplicationStatusLineChartLabels: any[];
  stepSize: number;
  // agentApplicationStatusLineKey
  // agentApplicationStatusLineValue;

  /**D3 variables starts*/
  dataList: any[];
  plotDetails: ChartYPlotDetails[];
  /**D3 variables ends*/
  lineChartData: any;
  lineChartOptions: any;
  lineChartPlugins: any;
  public currentSelectedTheme;
  constructor(agentService: AgentService, public settingService: SettingService, public router: Router) {
    super(agentService);
    // this.loadPieDetails();
  }

  ngOnInit() {
    setTimeout(() => {
      // this.loadPieChartDetails();
      this.loadBarChartDetails();
    }, 10);
    if (sessionStorage.getItem('userTypeIE') === 'MAKER') {
      this.searchName = 'SearchRecruitmentStatus';
    } else {
      this.searchName = 'SearchRecruitmentStatusChecker';
    }
    this.settingService.setWindowWidth(window);
    this.widthInPX = this.settingService.getWindowWidth();
  }

  /**
   * HostListener Decorator that declares a DOM event to listen for,
   * and provides a handler method to run when that event occurs.
   * The onresize event occurs when the browser window has been resized
   * @returns numeric value.
   */
  @HostListener('window:resize', ['$event'])
  onWindowResize(event) {
    if (event.target != undefined) {
      this.settingService.setWindowWidth(window);
      this.widthInPX = this.settingService.getWindowWidth();
    }
  }

  ////////////////////// For Bar Graph Methods ////////////////////
  onBarChartClick() {
    this.loadBarChartDetails();
  }

  // public loadBarChartDetails() {
  //   this.pieGraph = false;
  //   this.agentApplicationStatusBarChartData = [];
  //   this.service.getAgentApplicationStatus().subscribe(
  //     (agentApplicationStatus) => {
  //       for (let [key, value] of Object.entries(agentApplicationStatus['data'])) {
  //         let legend = {
  //           name: key,
  //           data: [value],
  //         };

  //         this.agentApplicationStatusBarChartData.push(legend);
  //       }
  //       setTimeout(() => {
  //         this.barChartBrowser();
  //       }, 1000);
  //     },
  //     (error) => {
  //       console.log('Error:', error);
  //     }
  //   );
  // }

  public loadBarChartDetails() {
    this.lineGraph = false;
    this.pieGraph = false;
    this.barGraph = true;
    this.agentApplicationStatusBarChartData = [];
    this.agentApplicationStatusBarChartLabels = [];
    this.pieColorArray = this.service.getColor();

    this.service.getAgentApplicationStatus().subscribe(
      (agentApplicationStatus) => {
        if (agentApplicationStatus != undefined)
          for (let [key, value] of Object.entries(agentApplicationStatus['data'])) {
            let legend = {
              name: key,
              data: value,
            };
            this.agentApplicationStatusBarChartLabels.push(legend.name);
            this.agentApplicationStatusBarChartData.push(legend.data);
          }
        setTimeout(() => {
          this.barChartBrowser();
        }, 10);
      },
      (error) => {
        console.log('Error:', error);
      }
    );
  }

  barChartBrowser() {
    if (this.agentApplicationStatusGraph != undefined) this.agentApplicationStatusGraph.destroy();
    this.agentApplicationStatusGraph = this.agentApplicationStatusGraph = new Chart('applBarCharts', {
      type: 'bar',
      data: {
        labels: this.agentApplicationStatusBarChartLabels,
        datasets: [
          {
            backgroundColor: this.pieColorArray,
            data: this.agentApplicationStatusBarChartData,
          },
        ],
      },
      options: {
        responsive: true,
        animation: {
          duration: 1,
          onComplete: function () {
            let chartInstance = this.chart,
              ctx = chartInstance.ctx;
            ctx.font = Chart.helpers.fontString(
              Chart.defaults.global.defaultFontSize,
              Chart.defaults.global.defaultFontStyle,
              Chart.defaults.global.defaultFontFamily
            );
            ctx.textAlign = 'center';
            ctx.textBaseline = 'bottom';
            ctx.fontColor = 'black';
            this.data.datasets.forEach(function (dataset, i) {
              let meta = chartInstance.controller.getDatasetMeta(i);
              meta.data.forEach(function (bar, index) {
                let data = dataset.data[index];
                ctx.fillText(data, bar._model.x, bar._model.y - 5);
              });
            });
          },
        },
        hover: () => {},
        tooltips: {
          enabled: true,
          mode: 'label',
        },
        maintainAspectRatio: true,
        onClick: (e, activeEls) => {
          console.log(activeEls);
          this.onGraphPointClick(activeEls);
        },
        scales: {
          xAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: 'Application Status',
                fontSize: this.settingService.isMobileViewRendered() ? 8 : 12,
                fontColor: 'black',
              },
              ticks: {
                fontSize: this.settingService.isMobileViewRendered() ? 8 : 12,
              },
            },
          ],
          yAxes: [
            {
              display: true,
              ticks: {
                fontSize: this.settingService.isMobileViewRendered() ? 8 : 12,
                stepSize: this.settingService.isMobileViewRendered() ? 100 : 40,
                callback: function (value, index, values) {
                  value = value.toString();
                  let value1 = value.split(/(?=(?:...)*$)/);
                  value = value1.join(',');
                  return value;
                },
                beginAtZero: true,
                min: 0,
              },
              scaleLabel: {
                display: true,
                labelString: 'Application Count',
                fontSize: this.settingService.isMobileViewRendered() ? 8 : 12,
                fontColor: 'black',
              },
            },
          ],
        },
        plugins: {
          plotpadding: 0.2,
          plotBackgroundColor: '#F4F4F4',
          plotBorderWidth: null,
          plotShadow: false,
          credits: {
            enabled: false,
          },
          datalabels: {
            color: '#000000',
          },
          events: {
            load() {
              const chart = this;
              chart.showLoading('Loading ...');
              setTimeout(function () {
                chart.hideLoading();
              }, 200);
            },
          },
          title: {
            display: false,
            text: null,
          },
        },
        legend: {
          labels: {
            fontSize: this.settingService.isMobileViewRendered() ? 8 : 12,
            padding: this.settingService.isMobileViewRendered() ? 5 : 10,
            boxWidth: this.settingService.isMobileViewRendered() ? 20 : 40,
            fontColor: 'black',
          },
          display: false,
          // position: 'bottom',
        },
      },
    });
    //   HighCharts.chart( 'charts', {
    //   chart: {
    //     type: 'column',
    //   },
    //   title: {
    //     text: null,
    //   },
    //   subtitle: {
    //     text: null,
    //   },
    //   xAxis: {
    //     categories: ['Application Status'],
    //   },
    //   yAxis: {
    //     min: 0,
    //     title: {
    //       text: 'Application Count',
    //     },
    //   },
    //   plotOptions: {
    //     column: {
    //       pointPadding: 0.2,
    //       borderWidth: 0,
    //       dataLabels: {
    //         enabled: true,
    //       },
    //     },
    //     series: {
    //       cursor: 'pointer',
    //       point: {
    //         events: {
    //           click: () => {
    //             this.onGraphPointClick(event);
    //           },
    //         },
    //       },
    //     },
    //   },
    //   series: this.agentApplicationStatusBarChartData,
    //   credits: {
    //     enabled: false,
    //   },
    // });
  }

  ////////////////////// For Pie Graph Methods ////////////////////
  onPieChartClick() {
    this.loadPieChartDetails();
  }

  private loadPieChartDetails() {
    this.lineGraph = false;
    this.pieGraph = true;
    this.barGraph = false;
    this.agentApplicationStatusPieChartData = [];
    this.allocationPercLabels = [];
    this.pieColorArray = this.service.getColor();
    this.pieGraph = true;
    let tooltip = {};
    this.service.getAgentApplicationStatus().subscribe(
      (agentApplicationStatus) => {
        if (agentApplicationStatus != undefined && agentApplicationStatus['data'] != undefined)
          for (let [key, value] of Object.entries(agentApplicationStatus['data'])) {
            tooltip = {
              name: key,
              y: Number(value),
            };
            this.allocationPercLabels.push(key);
            this.agentApplicationStatusPieChartData.push(value);
          }

        setTimeout(() => {
          this.pieChartBrowser();
        }, 10);
      },
      (error) => {
        console.log('Error:', error);
      }
    );
  }

  pieChartBrowser() {
    // if (this.agentApplicationStatusPieChartData && this.agentApplicationStatusPieChartData.length > 0) {
    if (this.agentApplicationStatusGraph) this.agentApplicationStatusGraph.destroy();

    this.agentApplicationStatusGraph = new Chart('pieCharts', {
      type: 'pie',
      data: {
        labels: this.allocationPercLabels,
        datasets: [
          {
            backgroundColor: this.pieColorArray,
            hoverBackgroundColor: this.pieColorArray,
            data: this.agentApplicationStatusPieChartData,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: true,
        onClick: (e, activeEls) => {
          this.onGraphPointClick(activeEls);
        },
        tooltips: {
          callbacks: {
            label: function (tooltipItems, data) {
              let total: number = 0;
              for (let i = 0; i < data.datasets[0].data.length; i++) {
                total = total + data.datasets[0].data[i];
              }
              const percentage = (data.datasets[tooltipItems.datasetIndex].data[tooltipItems.index] / total) * 100;
              const formattedPercentage = percentage % 1 === 0 ? percentage.toFixed(0) : percentage.toFixed(2);

              return data.labels[tooltipItems.index] + ' : ' + formattedPercentage + '%';
            },
          },
        },
        plugins: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          credits: {
            enabled: false,
          },
          title: {
            display: true,
            text: null,
          },
          datalabels: {
            font: function (context) {
              var width = context.chart.width;
              var size = Math.round(width / 32);
              console.log('width', width);
              console.log('size', size);

              return {
                weight: 'bold',
                size: size,
              };
            },
          },
        },
        legend: {
          display: true,
          onClick: () => {},
          position: 'bottom',
          //align: 'start',
          labels: {
            fontSize: this.settingService.isMobileViewRendered() ? 8 : 12,
            fontColor: 'black',
            boxWidth: this.settingService.isMobileViewRendered() ? 15 : 40,
            padding: this.settingService.isMobileViewRendered() ? 3 : 10,
            generateLabels: () => {
              var result = [];
              this.allocationPercLabels.forEach((label, i) => {
                result.push({
                  text: this.allocationPercLabels[i],
                  fillStyle: this.pieColorArray[i],
                });
              });
              return result;
            },
          },
        },
      },
    });

    //   HighCharts.chart( 'charts', {
    //   chart: {
    //     plotBackgroundColor: '#F4F4F4',
    //     plotBorderWidth: null,
    //     plotShadow: false,
    //     type: 'pie',
    //     events: {
    //       load() {
    //         const chart = this;
    //         chart.showLoading('Loading ...');
    //         setTimeout(function () {
    //           chart.hideLoading();
    //         }, 200);
    //       },
    //     },
    //   },
    //   title: {
    //     text: null,
    //   },
    //   plotOptions: {
    //     pie: {
    //       allowPointSelect: true,
    //       cursor: 'pointer',
    //       dataLabels: {
    //         enabled: false,
    //       },
    //       showInLegend: true,
    //       size: 250,
    //     },
    //     series: {
    //       cursor: 'pointer',
    //       point: {
    //         events: {
    //           click: () => {
    //             this.onGraphPointClick(event);
    //           },
    //         },
    //       },
    //     },
    //   },
    //   series: [
    //     {
    //       name: 'Application Count',
    //       type: 'pie',
    //       colorByPoint: true,
    //       allowPointSelect: true,
    //       data: this.agentApplicationStatusPieChartData,
    //     },
    //   ],
    //   credits: {
    //     enabled: false,
    //   },
    //   responsive: {
    //     rules: [
    //       {
    //         condition: {
    //           maxWidth: 400,
    //         },
    //       },
    //     ],
    //   },
    // });
  }
  // }

  ///////////////////////// For Line Graph Methods ////////////////////////
  onLineChartClick() {
    this.loadLineChartDetails();
  }

  // private loadLineChartDetails() {
  //   this.lineGraph = true;
  //   this.pieGraph = false;
  //   this.barGraph = false;
  //   this.agentApplicationStatusLineChartData = [];
  //   this.agentApplicationStatusLineChartLabels = [];
  //   // let tooltip;
  //   this.plotDetails = [];
  //   this.plotDetails = [
  //     {
  //       fieldCd: 'ApplicationStatus',
  //       displayedLabelText: 'ApplicationStatus',
  //     },
  //   ];
  //   this.service.getAgentApplicationStatus().subscribe(
  //     (agentApplicationStatus) => {
  //       this.dataList = [];
  //       for (let [key, value] of Object.entries(agentApplicationStatus['data'])) {
  //         this.dataList.push({ x: key, ApplicationStatus: value });
  //       }
  //       // for (let [key, value] of Object.entries(agentApplicationStatus['data'])) {
  //       // tooltip = {
  //       //   name: key,
  //       //   data: [0, value],
  //       // };
  //       // this.agentApplicationStatusLineChartData.push(tooltip);
  //       // }
  //       // setTimeout(() => {
  //       //    this.LineChartBrowser();
  //       // }, 100);
  //     },
  //     (error) => {
  //       console.log('Error:', error);
  //     }
  //   );
  // }

  loadLineChartDetails() {
    this.lineGraph = true;
    this.pieGraph = false;
    this.barGraph = false;

    this.lineChartData = null;
    this.lineChartOptions = null;
    this.lineChartPlugins = [];

    this.service.getAgentApplicationStatus().subscribe(
      (agentApplicationStatus) => {
        const labels: string[] = [];
        const values: number[] = [];

        for (let [status, count] of Object.entries(agentApplicationStatus['data'])) {
          labels.push(status);
          values.push(count as number);
        }

        this.lineChartData = {
          labels: labels,
          datasets: [
            {
              data: values,
              label: 'Application Count',
              fill: false,
              borderColor: '#3366CC',
              backgroundColor: '#3366CC',
              tension: 0.4,
            },
          ],
        };

        this.lineChartOptions = {
          responsive: true,
          maintainAspectRatio: false,
          layout: {
            padding: { left: 30, right: 30 },
          },
          legend: {
            position: 'bottom',
            labels: {
              fontSize: this.settingService.isMobileViewRendered() ? 8 : 12,
              padding: 10,
              boxWidth: 20,
              fontColor: this.currentSelectedTheme == 'dark' ? '#fff' : '#000',
              fontFamily: 'montserratregular, Arial, Helvetica, sans-serif',
            },
          },
          scales: {
            xAxes: [
              {
                scaleLabel: {
                  display: true,
                  labelString: 'Application Status',
                  fontSize: this.settingService.isMobileViewRendered() ? 8 : 12,
                  fontColor: this.currentSelectedTheme == 'dark' ? '#fff' : '#000',
                  fontFamily: 'montserratregular, Arial, Helvetica, sans-serif',
                },
                gridLines: {
                  color: this.currentSelectedTheme === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.1)',
                  zeroLineColor: this.currentSelectedTheme === 'dark' ? '#fff' : '#000',
                  drawBorder: true,
                  lineWidth: 1,
                },
                ticks: {
                  fontSize: this.settingService.isMobileViewRendered() ? 8 : 12,
                  fontColor: this.currentSelectedTheme == 'dark' ? '#fff' : '#000',
                  fontFamily: 'montserratregular, Arial, Helvetica, sans-serif',
                },
              },
            ],
            yAxes: [
              {
                display: true,
                ticks: {
                  beginAtZero: true,
                  min: 0,
                  fontSize: this.settingService.isMobileViewRendered() ? 8 : 12,
                  fontColor: this.currentSelectedTheme == 'dark' ? '#fff' : '#000',
                  fontFamily: 'montserratregular, Arial, Helvetica, sans-serif',
                  callback: function (value) {
                    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                  },
                },
                gridLines: {
                  color: this.currentSelectedTheme === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.1)',
                  zeroLineColor: this.currentSelectedTheme === 'dark' ? '#fff' : '#000',
                  drawBorder: true,
                  lineWidth: 1,
                },
                scaleLabel: {
                  display: true,
                  labelString: 'Application Count',
                  fontSize: this.settingService.isMobileViewRendered() ? 8 : 12,
                  fontColor: this.currentSelectedTheme == 'dark' ? '#fff' : '#000',
                  fontFamily: 'montserratregular, Arial, Helvetica, sans-serif',
                },
              },
            ],
          },
          plugins: {
            datalabels: false,
          },
          tooltips: {
            bodyFontFamily: 'montserratregular, Arial, Helvetica, sans-serif',
            callbacks: {
              title: (tooltipItems) => {
                return tooltipItems?.[0]?.label || '';
              },
            },
          },
          onClick: (e, activeEls) => {
            this.onGraphPointClick?.(activeEls);
          },
        };

        this.lineChartPlugins = [];
      },
      (error) => {
        console.log('Error:', error);
      }
    );
  }

  LineChartBrowser() {
    let lineChartData = [];
    for (let i = 0; i < this.agentApplicationStatusLineChartData.length; i++) {
      lineChartData.push({
        data: [
          this.agentApplicationStatusLineChartData[i].data[0],
          this.agentApplicationStatusLineChartData[i].data[1],
        ],
        label: this.agentApplicationStatusLineChartData[i].name,
        fill: false,
        // borderColor: this.service.getRandomColor(),
        borderColor: this.pieColorArray[i],
      });
      this.agentApplicationStatusLineChartLabels.push(this.agentApplicationStatusLineChartData[i].name);
    }
    if (this.agentApplicationStatusGraph) this.agentApplicationStatusGraph.destroy();
    this.agentApplicationStatusGraph = new Chart('lineCharts', {
      type: 'line',
      data: {
        //labels: this.agentApplicationStatusLineChartLabels,
        datasets: lineChartData,
      },
      options: {
        responsive: true,
        maintainAspectRatio: true,
        title: {
          text: null,
        },
        onClick: (e, activeEls) => {
          console.log('e', e);
          console.log('activeEls', activeEls);

          this.onGraphPointClick(activeEls);
        },
        tooltips: {
          callbacks: {
            title: () => null,
          },
        },
        legend: {
          labels: {
            fontSize: this.settingService.isMobileViewRendered() ? 8 : 12,
            padding: this.settingService.isMobileViewRendered() ? 10 : 10,
            boxWidth: this.settingService.isMobileViewRendered() ? 20 : 40,
            fontColor: 'black',
          },
          // align: 'center',
          position: 'bottom',
        },
        scales: {
          xAxes: [
            {
              scaleLabel: {
                labelString: 'Application Status',
                fontSize: this.settingService.isMobileViewRendered() ? 8 : 12,
                display: true,
              },
            },
          ],
          yAxes: [
            {
              display: true,
              ticks: {
                fontSize: this.settingService.isMobileViewRendered() ? 8 : 12,
                stepSize: this.settingService.isMobileViewRendered() ? 100 : 50,
                fontColor: 'black',
                callback: function (value, index, values) {
                  value = value.toString();
                  let value1 = value.split(/(?=(?:...)*$)/);
                  value = value1.join(',');
                  return value;
                },
                beginAtZero: true,
                min: 0,
              },
              scaleLabel: {
                display: true,
                labelString: 'Application Count',
                fontSize: this.settingService.isMobileViewRendered() ? 8 : 12,
                fontColor: 'black',
              },
            },
          ],
        },
      },
    });

    //   HighCharts.chart( {
    //   chart: {
    //     plotBackgroundColor: '#F4F4F4',
    //     renderTo: 'charts',
    //     type: 'line',
    //     events: {
    //       load() {
    //         const chart = this;
    //         chart.showLoading('Loading ...');
    //         setTimeout(function () {
    //           chart.hideLoading();
    //         }, 200);
    //       },
    //     },
    //   },
    //   title: {
    //     text: null,
    //   },
    //   xAxis: {},
    //   yAxis: {
    //     title: {
    //       text: 'Application Count',
    //     },
    //   },

    //   plotOptions: {
    //     series: {
    //       label: {
    //         connectorAllowed: false,
    //       },
    //       dataLabels: {
    //         enabled: true,
    //       },
    //       cursor: 'pointer',
    //       point: {
    //         events: {
    //           click: () => {
    //             this.onGraphPointClick(event);
    //           },
    //         },
    //       },
    //     },
    //   },

    //   series: this.agentApplicationStatusLineChartData,

    //   // series: [
    //   //   {
    //   //     name: this.agentApplicationStatusLineKey,
    //   //     type: 'line',
    //   //     colorByPoint: true,
    //   //     allowPointSelect: true,
    //   //     data: this.agentApplicationStatusLineValue,
    //   //   },
    //   // ],

    //   credits: {
    //     enabled: false,
    //   },
    // });
  }

  ///////////// On chart click method//////

  // onGraphPointClick(event) {
  //   if (event != null && event != undefined) {
  //     let agentApplicationStatus: any;
  //     if (this.pieGraph == true) {
  //       agentApplicationStatus = event.point.name;
  //     } else {
  //       agentApplicationStatus = event.point.series.name;
  //     }

  //     this.service.find(false, undefined).subscribe(
  //       (criteriaData) => {
  //         criteriaData['data']['searchCriteriaData']['PortalAgentDO.applicationStatusCd'] = agentApplicationStatus
  //           .replace('-', '')
  //           .replace(' ', '');

  //         this.settingService.setSessionStorageValue(
  //           'ApplicationStatus',
  //           JSON.stringify(criteriaData['data']['searchCriteriaData'])
  //         );
  //         console.log('testt', this.settingService.getSessionStorageValue('ApplicationStatus'));
  //         if (this.settingService.getSessionStorageValue('userTypeIE') === 'MAKER') {
  //           console.log('inside maker');
  //           this.router.navigate(['agent-graph-search']);
  //         } else {
  //           console.log('inside checker');
  //           this.router.navigate(['checker-graph-search']);
  //         }
  //       },
  //       (error) => {
  //         console.log('Criteria load failed', error);
  //       }
  //     );
  //   }
  // }

  onGraphPointClick(event) {
    if (event != null && event != undefined) {
      let agentApplicationStatus: any;
      if (this.pieGraph == true) {
        agentApplicationStatus = event[0]._model.label;
      } else {
        agentApplicationStatus = event[0]._model.label;
      }

      let applicationStatusList;
      let lookupList;
      this.service.getApplicationStatusLookup().subscribe(
        (body) => {
          applicationStatusList = JSON.parse(JSON.stringify(body));
          lookupList = { APPLICATIONSTATUS: applicationStatusList['data']['values'] };
          agentApplicationStatus = this.service.getCodeFromLookupDesc(
            'APPLICATIONSTATUS',
            agentApplicationStatus,
            lookupList
          );
          this.service.find(false).subscribe(
            (criteriaData) => {
              criteriaData['data']['searchCriteriaData']['PortalAgentDO.applicationStatusCd'] =
                agentApplicationStatus.toUpperCase().replace('-', '').replace(' ', '');
              this.settingService.setSessionStorageValue(
                'ApplicationStatus',
                JSON.stringify(criteriaData['data']['searchCriteriaData'])
              );

              if (this.settingService.getSessionStorageValue('userType') === 'MAKER-INTERNAL') {
                this.router.navigate(['agent-graph-search']);
              } else {
                this.router.navigate(['checker-graph-search']);
              }
            },
            (error) => {
              console.log('Criteria load failed', error);
            }
          );
        },
        (error) => {
          console.log('Error:', error);
        }
      );
    }
  }
}
